export default __webpack_public_path__ + "static/media/b08f4c7b88162671494b59e5c2c64a65.pdf";